interface PdfViewerNavigator {
  userAgent: string;
  platform?: string;
  maxTouchPoints?: number;
  pdfViewerEnabled?: boolean;
}

// iPadOS 13+ browses desktop-class by default: Safari reports a Macintosh user agent with no
// iPad token, so it is indistinguishable from a real Mac by user agent alone. Touch points are
// the discriminator — desktop Macs report 0, including models with a Touch Bar.
function isDesktopModeIpad(navigatorLike: PdfViewerNavigator): boolean {
  const isMacLike = navigatorLike.platform === 'MacIntel' || /Macintosh/i.test(navigatorLike.userAgent);

  return isMacLike && (navigatorLike.maxTouchPoints ?? 0) > 1;
}

export function requiresExternalPdfViewer(navigatorLike: PdfViewerNavigator): boolean {
  return (
    navigatorLike.pdfViewerEnabled === false ||
    /Android|iPhone|iPad|iPod|SamsungBrowser/i.test(navigatorLike.userAgent) ||
    isDesktopModeIpad(navigatorLike)
  );
}
